export default __webpack_public_path__ + "static/media/PC_ButtonActive.d1933357.svg";